module.exports = __webpack_public_path__ + "img/2.31e228c4.png";